(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-artist"] && !Shopify.designMode) return;
  try {
    
  
document.addEventListener("DOMContentLoaded", function () {
  const source = document.querySelector(".metafield-rich_text_field");
  const wrapper = document.querySelector(".slider-wrapper");
  const dotsContainer = document.querySelector(".dots");

  if (!source || !wrapper || !dotsContainer) return;

  const blocks = Array.from(source.children);
  const lineHeight = parseFloat(getComputedStyle(source).lineHeight || "24");
  const maxHeight = lineHeight * 11;

  const temp = document.createElement("div");
  Object.assign(temp.style, {
    position: "absolute",
    visibility: "hidden",
    width: source.offsetWidth + "px",
    fontSize: getComputedStyle(source).fontSize,
    lineHeight: getComputedStyle(source).lineHeight,
    whiteSpace: "normal",
    padding: getComputedStyle(source).padding,
  });
  document.body.appendChild(temp);

  let currentGroup = [];
  const slides = [];

  blocks.forEach(block => {
    temp.innerHTML = '';
    currentGroup.forEach(el => temp.appendChild(el.cloneNode(true)));
    temp.appendChild(block.cloneNode(true));

    if (temp.offsetHeight > maxHeight && currentGroup.length > 0) {
      const slide = document.createElement("div");
      slide.classList.add("slide");
      currentGroup.forEach(el => slide.appendChild(el.cloneNode(true)));
      slides.push(slide);
      currentGroup = [block];
    } else {
      currentGroup.push(block);
    }
  });

  if (currentGroup.length) {
    const slide = document.createElement("div");
    slide.classList.add("slide");
    currentGroup.forEach(el => slide.appendChild(el.cloneNode(true)));
    slides.push(slide);
  }

  document.body.removeChild(temp);

  // Create slider track for animation
  const track = document.createElement("div");
  track.classList.add("slider-track");
  wrapper.appendChild(track);

  slides.forEach((slide, i) => {
    track.appendChild(slide);

    const dot = document.createElement("span");
    dot.classList.add("dot");
    if (i === 0) dot.classList.add("active");
    dot.addEventListener("click", () => {
      resetAutoSlide();
      showSlide(i);
    });
    dotsContainer.appendChild(dot);
  });

  let currentIndex = 0;
  const showSlide = (index) => {
    const allDots = document.querySelectorAll(".dot");
    allDots.forEach(dot => dot.classList.remove("active"));
    allDots[index].classList.add("active");

    track.style.transform = `translateX(-${index * 100}%)`;
    currentIndex = index;
  };

  // Swipe Support
  let startX = 0;
  wrapper.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });

  wrapper.addEventListener("touchend", (e) => {
    let endX = e.changedTouches[0].clientX;
    let diff = startX - endX;

    if (Math.abs(diff) > 50) {
      resetAutoSlide();
      if (diff > 0 && currentIndex < slides.length - 1) {
        showSlide(currentIndex + 1); // Swipe left
      } else if (diff < 0 && currentIndex > 0) {
        showSlide(currentIndex - 1); // Swipe right
      }
    }
  });

  // Auto Slide
  let autoSlideInterval = null;
  let resumeTimeout = null;

  const startAutoSlide = () => {
    autoSlideInterval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    }, 5000); // every 5 seconds
  };

  const stopAutoSlide = () => {
    clearInterval(autoSlideInterval);
  };

  const resetAutoSlide = () => {
    stopAutoSlide();
    clearTimeout(resumeTimeout);
    resumeTimeout = setTimeout(startAutoSlide, 10000); // resume after 10 seconds
  };

  startAutoSlide();
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Tab switching
  const tabs = document.querySelectorAll(".faq-tabs .tab");
  const contents = document.querySelectorAll(".faq-contents .content");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const target = tab.dataset.tab;
      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");
      contents.forEach(c => c.classList.remove("active"));
      document.querySelector(".faq-contents ." + target).classList.add("active");
    });
  });

  // Accordion: only one open at a time, toggle on click
  document.addEventListener("click", function(e) {
    if (e.target.classList.contains("accordion-question")) {
      const question = e.target;
      const currentItem = question.closest(".accordion-item");
      const accordion = currentItem.parentElement;

      const isActive = question.classList.contains("active");

      // close all in this accordion
      accordion.querySelectorAll(".accordion-question").forEach(btn => {
        btn.classList.remove("active");
        btn.nextElementSibling.style.maxHeight = null;
      });

      // if it was not active, open it
      if (!isActive) {
        question.classList.add("active");
        const answer = question.nextElementSibling;
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
